import { c as _c } from "react/compiler-runtime";
import { LINKS } from '@/constants/links';
import usePromoSource from '@/hooks/usePromoSource';
import { ActionProps } from '@/types/actionProps';
import { getProductRegistrationLink } from '@/utils/registrationPromo';
import { useMemo } from 'react';
type LinkTarget = NonNullable<ActionProps['to']>;
export const useProductRegistrationLink = (defaultPromoSource, registrationLink) => {
  const $ = _c(6);
  const promoSource = usePromoSource();
  let t0;
  if ($[0] !== registrationLink) {
    t0 = registrationLink ?? LINKS().registration;
    $[0] = registrationLink;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const resolvedRegistrationLink = t0 as T;
  let t1;
  if ($[2] !== defaultPromoSource || $[3] !== promoSource || $[4] !== resolvedRegistrationLink) {
    t1 = getProductRegistrationLink({
      currentPromoSource: promoSource,
      defaultPromoSource,
      locale: process.env.NEXT_PUBLIC_LANGUAGE,
      registrationLink: resolvedRegistrationLink,
      registrationPath: LINKS().registration
    });
    $[2] = defaultPromoSource;
    $[3] = promoSource;
    $[4] = resolvedRegistrationLink;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export function useProductRegistrationButtons(buttons, defaultPromoSource) {
  const $ = _c(4);
  const promoSource = usePromoSource();
  let t0;
  if ($[0] !== buttons || $[1] !== defaultPromoSource || $[2] !== promoSource) {
    t0 = buttons?.map(button => ({
      ...button,
      to: button.to ? getProductRegistrationLink({
        currentPromoSource: promoSource,
        defaultPromoSource,
        locale: process.env.NEXT_PUBLIC_LANGUAGE,
        registrationLink: button.to,
        registrationPath: LINKS().registration
      }) : button.to
    })) ?? null;
    $[0] = buttons;
    $[1] = defaultPromoSource;
    $[2] = promoSource;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}